import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
async function fetchBuildTimestamp() {
    try {
        const response = await fetch('./build-timestamp.txt', { cache: 'no-store' });
        if (!response.ok) {
            return;
        }
        const str = await response.text();
        const buildTimestamp = Number(str);
        if (!isNaN(buildTimestamp)) {
            return buildTimestamp;
        }
    }
    catch {
        // return nothing
    }
}
/**
 * Checks to see if there's a newer version of the client by reading the build-timestamp.txt file.
 * If the timestamp is newer than what was initially recorded, there's a new client version, so prompt the user to
 * refresh.
 * The build timestamp will re-fetch whenever the window is refocused (default behavior of react-query), which is
 * especially useful on mobile if the user switches back to the PWA or browser window after it had been loaded at
 * some earlier time.
 */
export const BuildTimestampChecker = () => {
    const dispatch = useAppDispatch();
    const [initialBuildTimestamp, setInitialBuildTimestamp] = useState();
    const isMounted = useMountedState();
    const { data: buildTimestamp } = useQuery({ queryKey: ['build-timestamp-check'], queryFn: fetchBuildTimestamp });
    useEffect(() => {
        if (!buildTimestamp) {
            return;
        }
        if (!isMounted()) {
            return;
        }
        if (!initialBuildTimestamp) {
            setInitialBuildTimestamp(buildTimestamp);
        }
        else if (buildTimestamp > initialBuildTimestamp) {
            // client is outdated
            dispatch(addMessageBox({ type: 'new-client-available' }));
        }
    }, [buildTimestamp, dispatch, initialBuildTimestamp, isMounted]);
    return null;
};
